import React from 'react';
import { useParams } from 'react-router-dom';

export type ParamsProps<
    TParams extends Record<string, string | undefined> = Record<
        string,
        string | undefined
    >,
> = {
    params: Readonly<Partial<TParams>>;
};

export default function withParams<
    P extends object,
    TParams extends Record<string, string | undefined> = Record<
        string,
        string | undefined
    >,
>(Wrapped: React.ComponentType<P & ParamsProps<TParams>>) {
    return function WithParams(props: P) {
        const params = useParams() as Readonly<Partial<TParams>>;
        return <Wrapped {...props} params={params} />;
    };
}
